/*
 * Main entry file for public JS and CSS
 */

/* Main Scripts */
require("./scripts/master.js");

/* Main Styles */
require('./styles/master.scss');